import { configureStore } from "@reduxjs/toolkit";
import executorReducer from "./slices/executorSlice";
import sessionReducer from "./slices/sessionSlice";

export const store = configureStore({
  reducer: {
    executor: executorReducer,
    session: sessionReducer,
  },
});

export default store;
